import { Item } from "dsabp-js"
import { createCanvas } from "../canvas.js"
import { rendererResolvers } from "../main.js"
import { getImage, toImage } from "../util.js"

rendererResolvers.push(
	({ item }) => {
		if (item != Item.TURRET_CONTROLLER)
			return

		return {
			discriminator: `${item.id}`,
			async render() {
				const img = await getImage("turret_controller")

				const canvas = createCanvas(img.width, img.height)
				canvas.getContext("2d").drawImage(img, 0, 0)

				return [{
					image: await toImage(canvas),
					baseBoundOff: { x: 0.2, y: 0.2 }
				}]
			}
		}
	}
)
